"use client";
import { Programme } from "@/data/programmes";
import { useState } from "react";

type ProgrammeDescriptionProps = {
  prog: Programme | undefined;
};
export function ProgrammeDescription({ prog }: ProgrammeDescriptionProps) {
  const [descExpanded, setDescExpanded] = useState(false);
  const shouldShowButton =
    prog?.overview.description && prog.overview.description.length > 150;
  return (
    <div className="max-w-3xl mb-8">
      <p
        className={`text-healing-800 text-lg font-semibold ${!descExpanded && shouldShowButton ? "line-clamp-4 md:line-clamp-3" : ""}`}
      >
        {prog?.overview.description}
      </p>
      {shouldShowButton && (
        <button
          onClick={() => setDescExpanded(!descExpanded)}
          className="text-healing-700 hover:text-healing-900 text-sm font-semibold mt-2 transition-colors"
        >
          {descExpanded ? "← See less" : "See more →"}
        </button>
      )}
    </div>
  );
}
